module.exports = __webpack_public_path__ + "static/img/03.fb0e435.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/03.jpg
// module id = r3Ut
// module chunks = 0